export const SITES = ['US', 'DE', 'UK', 'FR', 'IT', 'ES', 'JP'];

// Category Colors/Icons map
export const CAT_CONFIG: Record<string, { color: string, icon?: any }> = {
    'media': { color: 'blue' },
    'text': { color: 'cyan' },
    'price': { color: 'gold' },
    'social': { color: 'magenta' },
    'traffic': { color: 'purple' },
    'data': { color: 'geekblue' },
    'other': { color: 'default' },
};

export const CATEGORY_ORDER = ['media', 'text', 'price', 'social', 'traffic', 'data', 'other'];
